import Swiper, {
  Autoplay,
  Mousewheel,
  Navigation,
  Pagination,
  Scrollbar,
  Thumbs,
  Controller,
  Grid
} from 'swiper';
import 'swiper/swiper-bundle.css';

Swiper.use([
  Navigation,
  Pagination,
  Autoplay,
  Scrollbar,
  Mousewheel,
  Thumbs,
  Controller,
  Grid
]);

class SwipersSliders {
  static instance = null;

  constructor(el) {
    this.el = el;
    this.mySwiper = null;
    this.init();
    this.mobileSwiper();
  }

  static create(el) {
    if (SwipersSliders.instance === null) {
      if (el) {
        SwipersSliders.instance = new SwipersSliders(el);
      }
    }
  }

  static destroy() {
    if (SwipersSliders.instance) {
      SwipersSliders.instance.beforeDestroy();
      SwipersSliders.instance = null;
    }
  }

  init() {
    const swiperTwitter = this.el.querySelectorAll('.swiper-twitter');
    if (!!swiperTwitter.length) {
      this.twiterSlides = new Swiper('.swiper-twitter', {
        slidesPerView: 1.1,
        draggable: true,
        mousewheel: true,
        spaceBetween: 24,
        loop: true,
        pagination: {
          el: '.section-updates .swiper-pagination',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return ('0' + current).slice(-2) + '/' + ('0' + total).slice(-2);
          },
        },
        navigation: {
          nextEl: '.section-updates .swiper-button-next',
          prevEl: '.section-updates .swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 33,
          },
          1280: {
            slidesPerView: 3,
            spaceBetween: 56,
          },
        },
      });
    }
    const swiperNews = this.el.querySelectorAll('.swiper-news');
    if (swiperNews.length) {
      this.newsSlides = new Swiper('.swiper-news', {
        slidesPerView: 1.1,
        spaceBetween: 33,
        loop: true,
        pagination: {
          el: '.section-newsfeed .swiper-pagination',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return ('0' + current).slice(-2) + '/' + ('0' + total).slice(-2);
          },
        },
        navigation: {
          nextEl: '.section-newsfeed .swiper-button-next',
          prevEl: '.section-newsfeed .swiper-button-prev',
        },
        breakpoints: {
          767: {
            slidesPerView: 2.1,
            spaceBetween: 20,
          },
          1024: {
            slidesPerView: 3.1,
            spaceBetween: 20,
          },
        },
      });

      const screenWidth = window.matchMedia('(min-width:768px)');
      if (screenWidth.matches === true) {
        if (this.newsSlides.slides.length > 4) {
          this.newsSlides.el.classList.add('slider-init');
        }
      }
    }

    const swiperBlog = this.el.querySelectorAll('.swiper-blog');
    if (swiperBlog.length) {
      this.blogSlides = new Swiper('.swiper-blog', {
        slidesPerView: 2,
        spaceBetween: 16,
        centeredSlides: false,
        loop: true,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 16,
          },
          1024: {
            slidesPerView: 2,
          },
          1280: {
            slidesPerView: 2,
          },
        },
      });
    }

    const swiperQuote = this.el.querySelectorAll('.quote-slider');
    if (swiperQuote.length) {
      this.quoteSlides = new Swiper('.quote-slider', {
        slidesPerView: 1,
        loop: true,
        autoplay: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: 'true',
        },
      });
    }

    const swiperCsBuilder = this.el.querySelectorAll('.cs-builder-slider');
    if (swiperCsBuilder.length) {
      this.quoteSlides = new Swiper('.cs-builder-slider', {
			slidesPerView: 1,
			autoplay: {
				delay: 7000,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});

    const startAutoplay = (entries, observer) => {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					this.quoteSlides.autoplay.start();
				} else {
					this.quoteSlides.autoplay.stop();
				}
			});
		};

		const observer = new IntersectionObserver(startAutoplay, {
			root: null,
			threshold: 0.5,
		});

		observer.observe(swiperCsBuilder[0]);

      const items = this.el.querySelectorAll('.cs-opp-boxes .box');
      items.forEach((item, i) => {
        item.addEventListener('click', (e) => {
          e.preventDefault();

          // const target = document.querySelector('.cs-builder-slider-box');
          // window.scroller.scrollTo(target, {
          //   offset: -100,
          //   duration: 800,
          //   ease: 'easeInOutQuart'
          // })

          setTimeout(() => {
            this.quoteSlides.slideTo(i);
          }, 175);
        });
      });
    }

    const swiperPagination = this.el.querySelectorAll('.pagination-slider');
    if (swiperPagination.length) {
      if (swiperPagination[0].classList.contains('single-video')) {
        const speed = 300;
        function goNext(el) {
          const displayDuration =
            (parseInt(el.slides[el.activeIndex].dataset.displayDuration) || 1) *
              1000 -
            speed;

          if (el.activeIndex + 1 === el.slides.length) {
            setTimeout(() => {
              const singleVideo = document.querySelector(
                '.idp-slider.single-video iframe'
              );
              singleVideo.setAttribute('src', singleVideo.getAttribute('src'));
              el.slideTo(0);
            }, displayDuration);
          } else {
            setTimeout(() => {
              el.slideNext();
            }, displayDuration);
          }
        }

        var paginationSlides = new Swiper('.pagination-slider', {
          slidesPerView: 1,
          centeredSlides: true,
          roundLengths: true,
          speed: speed,
          loop: false,
          allowTouchMove: false,
          breakpoints: {
            768: {
              direction: 'vertical',
              slidesPerView: 5,
            },
          },
          on: {
            afterInit: function () {
              goNext(this);
            },
            slideChangeTransitionEnd: function () {
              goNext(this);
            },
          },
        });
      } else {
        var paginationSlides = new Swiper('.pagination-slider', {
          slidesPerView: 1,
          centeredSlides: true,
          roundLengths: true,
          // loop: true,
          autoplay: {
            delay: 5000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number) {
              return ('0' + number).slice(-2);
            },
            formatFractionTotal: function (number) {
              return ('0' + number).slice(-2);
            },
            renderFraction: function (currentClass, totalClass) {
              return (
                '<span class="' +
                currentClass +
                '"></span>' +
                '/' +
                '<span class="' +
                totalClass +
                '"></span>'
              );
            },
          },
          breakpoints: {
            768: {
              direction: 'vertical',
              slidesPerView: 5,
            },
          },
        });

        this.imageSlides = new Swiper('.image-slider', {
          slidesPerView: 1,
          loop: true,
          allowTouchMove: false,
          on: {
            transitionEnd: function () {
              let activeSlide = $('.swiper-slide-active');
              let caption = activeSlide.data('caption');
              let linkSlide = activeSlide.data('url');
              $('.img-caption').text(caption);
              if (linkSlide) {
                $('.img-caption').attr('href', linkSlide);
              } else {
                $('.img-caption').removeAttr('href');
              }
            },
          },
        });

        paginationSlides.on('slideChangeTransitionEnd', () => {
          let index = $('.pagination-slider .swiper-slide-active').data(
            'swiper-slide-index'
          );
          this.imageSlides.slideTo(index);
        });

        var paginationSlidesModal = new Swiper('.pagination-slider-modal', {
          slidesPerView: 1,
          centeredSlides: true,
          roundLengths: true,
          //loop: true,
          navigation: {
            nextEl: '.swiper-button-next-modal',
            prevEl: '.swiper-button-prev-modal',
          },
          pagination: {
            el: '.swiper-pagination-modal',
            type: 'fraction',
            formatFractionCurrent: function (number) {
              return ('0' + number).slice(-2);
            },
            formatFractionTotal: function (number) {
              return ('0' + number).slice(-2);
            },
            renderFraction: function (currentClass, totalClass) {
              return (
                '<span class="' +
                currentClass +
                '"></span>' +
                '/' +
                '<span class="' +
                totalClass +
                '"></span>'
              );
            },
          },
          breakpoints: {
            768: {
              slidesPerView: 5,
            },
          },
        });

        var imageSlidesModal = new Swiper('.image-slider-modal', {
          slidesPerView: 1,
          centeredSlides: true,
          allowTouchMove: false,
          //loop: true,
          on: {
            transitionEnd: function () {
              let activeSlideModal = $(
                '.image-slider-modal .swiper-slide-active'
              );
              let captionModal = activeSlideModal.data('caption');
              let linkModal = activeSlideModal.data('url');
              console.log(linkModal);
              $('.img-caption-modal').text(captionModal);

              if (linkModal) {
                $('.img-caption-modal').attr('href', linkModal);
              } else {
                $('.img-caption-modal').removeAttr('href');
              }
            },
          },
        });

        let progressBar = $('.progress-bar');

        $('[data-modal]').on('click', function () {
          let index = $(this)
            .closest('.swiper-slide-active')
            .data('swiper-slide-index');
          imageSlidesModal.slideTo(index);
          paginationSlidesModal.slideTo(index);
          var activeSlide =
            imageSlidesModal.slides[imageSlidesModal.activeIndex];
          var vimeo = activeSlide.querySelector('iframe');
          if (vimeo) {
            var dataHref = vimeo.getAttribute('data-href');
            $(vimeo).attr('src', dataHref);
          }
          paginationSlides.autoplay.stop();
          $(progressBar).removeClass('progress-bar');
        });

        $('.modal .close').click(function (e) {
          e.preventDefault();
          paginationSlides.autoplay.start();
          $(progressBar).addClass('progress-bar');
        });

        $('html').on(
          'click touchstart pointerdown MSPointerDown',
          function (e) {
            paginationSlides.autoplay.start();
            $(progressBar).addClass('progress-bar');
          }
        );

        paginationSlidesModal.on('slideChange', () => {
          let nextButton = $(
            '.swiper-button-next-modal.swiper-button-disabled'
          );
          let totalSlides = paginationSlidesModal.slides.length;
          if (paginationSlidesModal.activeIndex === totalSlides - 1) {
            nextButton.on('click', function () {
              if (nextButton.hasClass('swiper-button-disabled')) {
                paginationSlidesModal.slideTo(0);
              } else {
                nextButton.off('click');
              }
            });
          }
          imageSlidesModal.slideTo(paginationSlidesModal.activeIndex);
        });

        imageSlidesModal.on('slideChange', () => {
          pauseAllVideos();
          var activeSlide =
            imageSlidesModal.slides[imageSlidesModal.activeIndex];
          var video = activeSlide.querySelector('video');
          var vimeo = activeSlide.querySelector('iframe');
          if (vimeo) {
            var dataHref = vimeo.getAttribute('data-href');
            $(vimeo).attr('src', dataHref);
          }
          if (video) {
            video.play();
          }
        });

        function pauseAllVideos() {
          var videos = document.querySelectorAll('video');
          var vimeo = document.querySelectorAll('iframe');
          videos.forEach(function (video) {
            if (!video.paused) {
              video.pause();
            }
          });

          vimeo.forEach(function (video) {
            video.removeAttribute('src');
          });
        }
      }
    }

    const swiperPartner = this.el.querySelectorAll('.partner-slider');
    if (swiperPartner.length) {
      this.partnerSlides = new Swiper('.partner-slider', {
        slidesPerView: 1,
        // centeredSlides: true,
        spaceBetween: 26,
        loop: true,
        watchSlidesProgress: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination-fraction',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return (
              '<span class="current">' +
              (current >= 10 ? '' : '0') +
              current +
              '</span>' +
              '/' +
              '<span class="total">' +
              (total >= 10 ? '' : '0') +
              total +
              '</span>'
            );
          },
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 3,
          },
          1280: {
            slidesPerView: 4,
          },
        },
      });
    }

    const swiperInnovators = this.el.querySelectorAll('.innovators-slider');
    if (swiperInnovators.length) {
      this.InnovatorsSlides = new Swiper('.innovators-slider', {
        slidesPerView: 1,
            loop: true,
            // autoplay: {
            //   delay: 4000,
            //   disableOnInteraction: true,
            // },
            autoplay: false,
    
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
    
            pagination: {
              el: '.swiper-pagination-fraction',
              type: 'custom',
              renderCustom: function (swiper, current, total) {
                return (
                  '<span class="current">' +
                  (current >= 10 ? '' : '0') +
                  current +
                  '</span>' +
                  '/' +
                  '<span class="total">' +
                  (total >= 10 ? '' : '0') +
                  total +
                  '</span>'
                );
              },
            },
      });
    }

    const swiperPost = this.el.querySelectorAll('.nl-post-slider');
    if (swiperPost.length) {
        this.partnerSlides = new Swiper('.nl-post-slider', {
          slidesPerView: 1,
          roundLengths: true,
          spaceBetween: 48,
          loop: true,
          watchSlidesProgress: true,

          autoplay: {
            delay: 6000,
            disableOnInteraction: true,
          },

          breakpoints: {
            768: {
              slidesPerView: 1.5,
              spaceBetween: 33,
            },
            920: {
              slidesPerView: 2,
              spaceBetween: 33,
            },
            1280: {
              centeredSlides: true,
              slidesPerView: 2.2,
              spaceBetween: 56,
            },
          },

          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },

          pagination: {
            el: '.swiper-pagination-fraction',
            type: 'custom',
            renderCustom: function (swiper, current, total) {
              const isRenderTwice = swiper.el.classList.contains('render-twice');
              const isRenderThreeTimes = swiper.el.classList.contains('render-three');
              var totalSlides = total;
              var currentSlide = current;

              const activeItem = (sector, swiper) => {
                const prevEl = swiper.el.previousElementSibling;
                if (prevEl?.classList.contains("post-slider-navigation")) {
                  const items = [...prevEl.children];
                  // Remove active class from all items
                  items.forEach((e) => e.classList.remove("item-active"));
                  // Find and activate the correct sector item
                  items.forEach((item) => {
                    if (item.textContent.trim() === sector) {
                      item.classList.add("item-active");
                    }
                  });
                }
              };

              // Get the sector of the current slide
              const currentSlideSector = swiper.slides[current - 1]
                ?.querySelector('.eyebrow-label')
                ?.textContent.trim();
              if (currentSlideSector) {
                activeItem(currentSlideSector, swiper);
              }

              if (isRenderTwice) {
                totalSlides = total / 2;
                currentSlide = current % totalSlides || totalSlides;
              }
              if (isRenderThreeTimes) {
                totalSlides = total / 3;
                currentSlide = current % totalSlides || totalSlides;
              }

              return (
                '<span class="current">' +
                (currentSlide >= 10 ? '' : '0') +
                currentSlide +
                '</span>' +
                '/' +
                '<span class="total">' +
                (totalSlides >= 10 ? '' : '0') +
                totalSlides +
                '</span>'
              );
            },
          },

          on: {
            slideChange: function (swiper) {
              updateActiveSector(swiper);
            },
            init: function (swiper) {
              updateActiveSector(swiper);
            },
          },
      });

      function updateActiveSector(swiper) {
        const activeSlide = swiper.slides[swiper.activeIndex];
        const activeSector = activeSlide
          .querySelector('.eyebrow-label')
          ?.textContent.trim();

        const prevEl = swiper.el.previousElementSibling;
        if (
          prevEl?.classList.contains('post-slider-navigation') &&
          activeSector
        ) {
          const items = [...prevEl.children];
          items.forEach((item) => {
            item.classList.remove('item-active');
            if (item.textContent.trim() === activeSector) {
              item.classList.add('item-active');
            }
          });
        }
      }

      this.partnerSlides?.forEach((swiper) => {
        swiper.autoplay.stop();
        const prevEl = swiper.el.previousElementSibling;
        if (prevEl?.classList.contains('post-slider-navigation')) {
          const items = [...prevEl.children];

          // Add a single event listener on the document for delegation
          document.addEventListener('click', (event) => {
            const item = event.target.closest(
              '.post-slider-navigation > *'
            );

            if (item && items.includes(item)) {
              // Reset all items and set active state for the clicked item
              items.forEach((el) =>
                el.classList.remove('item-active')
              );
              item.classList.add('item-active');
              swiper.slideToLoop(item.dataset.index);
            }
          });
        }
      });

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.swiper.autoplay.start();
            } else {
              entry.target.swiper.autoplay.stop();
            }
          });
        },
        {
          root: null,
          threshold: 0.1,
        }
      );

      swiperPost.forEach(item =>  observer.observe(item));
    }

    const swiperImgCard = this.el.querySelectorAll('.img-card-slider');
    if (swiperImgCard.length) {
      this.partnerSlides = new Swiper('.img-card-slider', {
        slidesPerView: 'auto',
        centeredSlides: true,
        spaceBetween: 43,
        loop: false,
        watchSlidesProgress: true,

        autoplay: {
          delay: 4000,
          disableOnInteraction: true,
        },

        breakpoints: {
          480: {
            centeredSlides: false,
          },
        },
      });
    }

    const swiperPartnerDetails = $('.partner-details-slider');
    let swiperInstance;
    if (swiperPartnerDetails.length) {
      swiperInstance = new Swiper('.partner-details-slider', {
        slidesPerView: 1,
        centeredSlides: true,
        spaceBetween: 40,
        loop: true,
        watchSlidesProgress: true,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        pagination: {
          el: '.swiper-pagination-fraction',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return (
              '<span class="current">' +
              (current >= 10 ? '' : '0') +
              current +
              '</span>' +
              '/' +
              '<span class="total">' +
              (total >= 10 ? '' : '0') +
              total +
              '</span>'
            );
          },
        },
      });

      $('a[data-slide]').on('click', function (event) {
        event.preventDefault();
        const slideIndex = parseInt($(this).attr('data-slide'));
        if (swiperInstance && !isNaN(slideIndex)) {
          /*
          * Tweak to unfreeze the navigation buttons after re-opening the modal
          */
          setTimeout(() => {
            swiperInstance.slideToLoop(slideIndex, 10, () => {
              setTimeout(() => {
                const translate = swiperInstance.getTranslate();
                swiperInstance.setTranslate(translate, 0.1, () => {
                  swiperInstance.setTranslate(translate);
                });
              }, 10);
            });
          }, 20);
        }
      });
    }

    if (this.el.querySelectorAll('.swiper-stories#specialists-swiper').length) {
      this.el
        .querySelectorAll('.swiper-stories#specialists-swiper')
        .forEach((holder) => {
          const breakpoint = window.matchMedia('(max-width:767px)');
          let swiper;
          const resizeHandler = () => {
            if (breakpoint.matches) {
              if (swiper !== undefined) swiper.destroy(true, true);
              $(holder)
                .children()
                .removeClass('swiper-wrapper')
                .addClass('cio-slider');
              $(holder).find('.swiper-slide').removeClass('swiper-slide');
              return;
            } else {
              $(holder)
                .children()
                .addClass('swiper-wrapper')
                .removeClass('cio-slider')
                .children()
                .addClass('swiper-slide');
              swiper = new Swiper(holder, {
                slidesPerView: 1.001,
                loop: true,
                pagination: {
                  el: '.swiper-pagination',
                  type: 'custom',
                  renderCustom: function (swiper, current, total) {
                    return (
                      ('0' + current).slice(-2) + '/' + ('0' + total).slice(-2)
                    );
                  },
                },
                navigation: {
                  nextEl: '.swiper-button-next',
                  prevEl: '.swiper-button-prev',
                },
              });
              return;
            }
          };
          breakpoint.addListener(resizeHandler);
          resizeHandler();
        });
    }

    // no swiping
    const noswipe = $('.swiper-slide').find('h2, p');
    noswipe.addClass('swiper-no-swiping');

    const swiperGallery = this.el.querySelectorAll('.swiper-gallery-section');
    const swiperGallerySlideTotal = this.el.querySelectorAll(
      '.swiper-gallery-section .swiper-slide'
    ).length;
    if (swiperGallery.length) {
      this.gallerySlides = new Swiper('.swiper-gallery', {
        slidesPerView: 1.12,
        spaceBetween: 40,
        loop: false,
        pagination: {
          el: '.swiper-gallery-section .swiper-pagination',
          type: 'custom',
          renderCustom: (swiper, current, total) => {
            const totalSlides = swiperGallerySlideTotal;
            const perView = 1;
            const totalPages = Math.ceil(totalSlides / perView);
            const currentSlide =
              current <= totalPages
                ? current
                : current % totalPages || totalPages;
            return (
              ('0' + currentSlide).slice(-2) + '/' + `0${totalPages}`.slice(-2)
            );
          },
        },
        navigation: {
          nextEl: '.swiper-gallery-section .swiper-button-next',
          prevEl: '.swiper-gallery-section .swiper-button-prev',
        },
        breakpoints: {
          1024: {
            slidesPerView: 1,
            spaceBetween: 70,
          },
          1180: {
            spaceBetween: 90,
          },
          1280: {
            spaceBetween: 135,
          },
        },
        // on: {
        //   beforeInit: function (swiper) {
        //     if (swiper.el.querySelectorAll('.swiper-slide').length == 0) return;
        //     for (let index = 0; index < 1; index++) {
        //       swiper.el
        //         .querySelectorAll('.swiper-slide')
        //         .forEach(function (element) {
        //           let clone = element.cloneNode(true);
        //           swiper.el
        //             .querySelectorAll('.swiper-wrapper')[0]
        //             .appendChild(clone);
        //         });
        //     }
        //   },
        // },
      });
    }

    const swiperEventsOverview = this.el.querySelectorAll(
      '.events-overview-slider'
    );
    if (swiperEventsOverview.length) {
      this.quoteSlides = new Swiper('.events-overview-slider', {
        slidesPerView: 'auto',
        spaceBetween: 10,
        loop: true,
        autoplay: false,
        speed: 1000,
        pagination: {
          el: '.swiper-pagination',
          type: 'custom',
          renderCustom: function (swiper, current, total) {
            return ('0' + current).slice(-2) + '/' + ('0' + total).slice(-2);
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        breakpoints: {
          768: {
            slidesPerView: 1,
          },
          769: {
            slidesPerView: 'auto',
          },
        },
      });
    }

    this.mobileSwiper('[data-mobile-swiper]', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 24,
      centeredSlides: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    });

    this.mobileSwiper(".judge-list-slider", {
      loop: false,
      slidesPerView: 1,
      grid: {
        rows: 3,
        fill: "row",
      },
      navigation: {
        nextEl: ".judge-list-slider .swiper-button-next:not(.a)",
        prevEl: ".judge-list-slider .swiper-button-prev:not(.a)",
      },
      on: {
        init: (swiper) => {
          document.addEventListener("click", (event) => {
            const item = event.target.closest(
              ".judge-list-slider .swiper-control > .a"
            );
            if (item) {
              if (item.classList.contains("swiper-button-prev")) {
                swiper.slideTo(swiper.snapGrid.length - 1);
              }

              if (item.classList.contains("swiper-button-next")) {
                swiper.slideTo(0);
              }
            }
          });
        },
        progress(swiper, progress) {
          if (progress < -0.01) {
            swiper.slideTo(swiper.snapGrid.length - 1)
          }
          if(progress > 1.01) {
            setTimeout(() => {
              swiper.slideTo(0);
            }, 100);
          }
        }
      },
    });

    const episodesSlider = new Swiper('.episodes-slider', {
      slidesPerView: 3,
      spaceBetween: 20,
      slideToClickedSlide: true,
      initialSlide: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerGroup: 1,
      centeredSlides: true,
      on: {
        // Update the featured content when slide changes
        slideChange: function () {
          updateFeaturedContent(this.activeIndex);
        },
      },
    });

    const gtEpisodesSlider = new Swiper('.gt-episodes-slider', {
		slidesPerView: 1.5,
		spaceBetween: 20,
		slideToClickedSlide: false,
		initialSlide: 0,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		slidesPerGroup: 1,
		centeredSlides: true,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
			},
			1024: {
				slidesPerView: 3.5,
			},
		},
		on: {
			click: function (swiper, event) {
				// Prevent clicking on disabled slides
				if (event.target.closest('.swiper-slide-disabled')) {
					event.stopPropagation();
					return false;
				}
			},

			// Update the featured content when slide changes
			slideChange: function () {
        if (this.slides[this.activeIndex].classList.contains('swiper-slide-disabled')) {
        const direction = this.activeIndex > this.previousIndex ? 'next' : 'prev';
        if (direction === 'next') {
          this.slideNext();
          updateFeaturedContent(this.activeIndex);
        } else {
          this.slidePrev();
          updateFeaturedContent(this.activeIndex);
        }
      }
				
			},
		},
	});

  $('.gt-episodes-slider .swiper-slide').on('click', function (e) {
		if (!$(e.target).closest('.play-btn[data-modal]').length) {
			const slideIndex = $(this).index();
			gtEpisodesSlider.slideTo(slideIndex);
		}
  });

  $('.gt-episodes-slider .play-btn[data-modal]').on('click', function (e) {
		e.preventDefault();
		e.stopPropagation();

		const modalId = $(this).attr('video-id');
		const index = $(this).attr('data-index');

		return false;
  });

    // Function to update featured content based on active slide
    function updateFeaturedContent(index) {
      if (!videosData[index]) return;

      const data = videosData[index];
      
      // Fade out all featured content first with scaling effect
      const $featuredContainer = $('.featured-content');
      const initialHeight = $('.game-theory-featured').height();
		  $('.game-theory-featured').css('height', initialHeight + 'px');
      $featuredContainer.fadeOut(300, function() {
          // Update video
          const $featuredVideo = $('.video-embed');
          if ($featuredVideo.length) {
              $featuredVideo.empty();

              if (data.video_file) {
                  // Create and append a video element if we have a video file
                  const videoElement = `
                      <video class="game-theory-video" width="100%" height="100%" loop muted autoplay>
                          <source src="${data.video_file.url}" type="${data.video_file.mime_type}">
                      </video>
                  `;
                  $featuredVideo.html(videoElement);
              }
          }

          // Update featured episode
          const $featuredEpisode = $('.featured-episode');
          if ($featuredEpisode.length && data.episode) {
              $featuredEpisode.text('Episode ' + data.episode);
          }

          // Update featured title
          const $featuredTitle = $('.featured-title');
          if ($featuredTitle.length) {
              $featuredTitle.text(data.title);
              if (data.move_down) {
                  $featuredTitle.css('margin-top', data.move_down + 'px');
              }
          }

          // Update featured guest
          const $featuredGuest = $('.featured-guest');
          if ($featuredGuest.length) {
              $featuredGuest.text(data.guest);
          }

          // Also update the play button link
          const $playBtn = $('.featured-content .thumbnail-buttons a');
          if ($playBtn.length && data.modal_id) {
              $playBtn.attr('video-id', data.modal_id);
              $playBtn.attr('data-index', index);
          }
          
          // Remove transitioning class and fade back in
          $featuredContainer.fadeIn(300, function () {
            // Reset to auto height after fade in completes
            $('.game-theory-featured').css('height', 'auto');
          });
      });
    }

    const modalThumbnailsSlider = new Swiper('.modal-thumbnails-slider', {
      slidesPerView: 1.5,
      spaceBetween: 10,
      slideToClickedSlide: true,
      initialSlide: 0,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      slidesPerGroup: 1,
      centeredSlides: true,
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
        1024: {
          slidesPerView: 4,
        },
        1300: {
          slidesPerView: 5,
        },
      },
    });
  }

  mobileSwiper(item, settings) {
    const breakpoint = window.matchMedia('(min-width:768px)');
    //const item = '[data-mobile-swiper]';

    if (!!document.querySelectorAll(item).length) {
      this.breakpointChecker = () => {
        if (breakpoint.matches === true) {
          if (this.mySwiper !== undefined && this.mySwiper !== null) {
            if (this.mySwiper.length > 1) {
              this.mySwiper.forEach((element) => {
                element.destroy(true, true);
              });
              this.checkDestroySwiper(this.mySwiper);
            } else {
              this.checkDestroySwiper([this.mySwiper]);
            }
            $(this.el)
              .find(item)
              .each(function () {
                $(this)
                  .removeClass('swiper-mobile')
                  .find('.row')
                  .removeClass('swiper-wrapper')
                  .children()
                  .removeClass('swiper-slide');
              });
          }
          return;
        } else if (breakpoint.matches === false) {
          $(this.el)
            .find(item)
            .addClass('swiper-mobile')
            .find('.row')
            .addClass('swiper-wrapper')
            .children()
            .addClass('swiper-slide');

          return this.enableSwiper();
        }
      };

      this.enableSwiper = () => {
        this.mySwiper = new Swiper(item, settings);
      };

      this.breakpointChecker();
      breakpoint.addEventListener('change', () => {
        this.breakpointChecker();
      });
    }
  }

  destroyMobile() {
    this.checkDestroySwiper([this.mySwiper]);
  }

  checkDestroySwiper(element) {
    element.forEach((el) => {
      if (typeof el !== 'undefined' && el !== null) {
        el.destroy(true, true);
        el = null;
      }
    });
  }

  destroySwipers() {
    this.checkDestroySwiper([
      this.twiterSlides,
      this.newsSlides,
      this.blogSlides,
      this.spotlightSlides,
      this.gallerySlides,
    ]);
  }

  beforeDestroy() {
    this.destroySwipers();
    this.destroyMobile();
  }
}

export default SwipersSliders;
